import { generatePath, useHistory, useParams } from "react-router-dom";
import routing from "routing";

import useQueryParams from "../../../hooks/useQueryParams";

export function RedirectQuestions() {
	const queryParams = useQueryParams();
	const { type } = useParams();
	const history = useHistory();

	return history.replace(generatePath(routing.paths.searchQuestion, { type }), {
		questions: JSON.parse(queryParams.get("questions")),
	});
}
